import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { OrganizationListItem, OrganizationState, Account, AccountState } from '@app/_store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap/dropdown';
import { SupportIconComponent } from '../../navigation/support-icon/support-icon.component';
import { AccountComponent } from '../../navigation/account/account.component';

@Component({
  selector: 'app-home-navigation',
  templateUrl: './home-navigation.component.html',
  styleUrls: ['./home-navigation.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgIf,
    RouterLink,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgFor,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgClass,
    RouterLinkActive,
    SupportIconComponent,
    AccountComponent,
    AsyncPipe,
  ],
})
export class HomeNavigationComponent {
  account$: Observable<Account> = inject(Store).select(AccountState.account);

  showHiddenAdminFeatures$: Observable<boolean> = inject(Store).select(AccountState.showHiddenAdminFeatures);

  organizations$: Observable<OrganizationListItem[]> = inject(Store).select(OrganizationState.organizations);
}
